import { Row } from "@tanstack/react-table";
import { KPIDetailsGroupDataType } from "../../../../../stores/types/campaignsTypes.tsx";
import { fullFormatNumbers } from "../../../../../helpers/functions/formatNumber.ts";

type Props = {
  row: Row<KPIDetailsGroupDataType>;
};

export const MediaPlanKpiSubComponent = ({ row }: Props) => {
  return (
    <table className="divide-x divide-monochrome-100">
      <thead className="bg-primary-505 divide-y divide-monochrome-200">
        <tr key={row.id + "head"}>
          <th
            // colSpan={row.getVisibleCells().length}
            className="pl-[54px] py-4 text-start typography-body-bold-sm text-monochrome-900  sticky z-10 left-0"
          >
            Platforms
          </th>
        </tr>
      </thead>
      <tbody className="bg-primary-508 divide-x divide-monochrome-100">
        {row.original.sub_groups?.map((subGroup, subIndex) => (
          <tr key={subGroup.id + "sub-group"}>
            <td
              key={subGroup.id + "sub-group-name"}
              className={`whitespace-nowrap text-sm text-monochrome-900 w-[207px] sticky z-10 left-0`}
            >
              <div className={`h-[66px] grid grid-cols-[52px_1fr]`}>
                <div className={`h-full bg-primary-505`}></div>
                <div
                  className={`${subIndex === 0 ? "border-y" : "border-b"} border-monochrome-100 border-l shadow-elevation-inset-right-100 px-3 py-2 bg-primary-508 flex items-center`}
                >
                  <p className="typography-body-sm text-monochrome-900">
                    {subGroup.name}
                  </p>
                </div>
              </div>
            </td>

            {Object.keys(subGroup.kpis).map((key) => {
              return (
                <td
                  key={subGroup.id + "sub-group-total" + key}
                  className={`${subIndex === 0 ? "border-y" : "border-b"}  border-r border-monochrome-100 px-4 py-3 whitespace-nowrap text-sm text-monochrome-900`}
                >
                  <div className="gap-y-0.5 flex flex-col items-end min-w-[118px]">
                    <p className="typography-body-sm text-monochrome-900">
                      $
                      {fullFormatNumbers({
                        value: subGroup.kpis[key],
                        noFormatNumber: true,
                        shortenValue: 1e3,
                      })}
                    </p>
                  </div>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
